import { render, staticRenderFns } from "./channel-list.vue?vue&type=template&id=35256360&scoped=true&"
import script from "./channel-list.vue?vue&type=script&lang=js&"
export * from "./channel-list.vue?vue&type=script&lang=js&"
import style0 from "./channel-list.vue?vue&type=style&index=0&id=35256360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35256360",
  null
  
)

export default component.exports